import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';
import ReportHelper from '../../report-helper';
import StatusHelper from '../../status-helper';
import ChartHelper from './chart-helper';
import { Container, Statistic, Message, List } from 'semantic-ui-react';


class MaintainabilityChart extends Component
{
    getData( history, fetchType )
    {
        return _.map(
            history,
            ( report ) => {
                const reportHelper = new ReportHelper( report );

                const covBase = {
                    maintainability : _.get( report, `data.plato.average.maintainability`, null )
                };

                covBase.name     = reportHelper.getReportName( fetchType );

                covBase.hash    = _.get( report, `data.pkg.hash` );
                covBase.tag     = _.get( report, `data.pkg.tag` );
                covBase.date    = _.get( report, `data.pkg.committed` );

                covBase.status  = _.get( report, `data.info.categoryStatus.maintainability` );

                return covBase;
            }
        );
    }


    getTooltip( content )
    {
        if( ( !content.payload ) || ( content.payload.length <= 0 ) )
        {
            return null;
        }

        const data = content.payload[ 0 ].payload,
            status = data.status.status;

        return ( <Container text={true} className={`maintainability ${data.status.status}`}>

            <Statistic label={'Average'} value={`${data.maintainability}`} />

            { !!data.status.message &&
                <Message
                    error={( status === 'error' )}
                    warning={( status === 'warning' )}
                    success={( status === 'ok')}
                    content={data.status.message}
                />
            }

            <List size={`small`} horizontal={true}>
                <List.Item header={`Hash`} description={ChartHelper.getHash( data.hash )} />
                <List.Item header={`Date`} description={moment( data.date ).format( 'YYYY-MM-DD hh:mm' )} />
                <List.Item header={`Tag`} description={data.tag || `n/a`} />
            </List>
        </Container> );
    }


    render()
    {
        const latest = _.get( this, 'props.pkg.latest' ),
            history = _.get( this, 'props.pkg.history' );

        if( !latest || !history )
        {
            return ( <div>Loading...</div> );
        }

        const colors = StatusHelper.getStatusColors( _.get( latest, `info.categoryStatus.maintainability.status` ) );

        return (
            <ResponsiveContainer width='100%' height='100%'>
                <LineChart className={_.get( latest, `info.categoryStatus.maintainability.status` )}
                           data={this.getData( history, this.props.fetchType )}
                           margin={{top: 8, right: 8, left: 8, bottom: 8}}>
                    <Tooltip content={this.getTooltip} />
                    <Line type="monotone" dataKey="maintainability" strokeWidth={2} stroke={colors.lineColors[ 0 ]} activeDot={{r: 8}}/>
                </LineChart>
            </ResponsiveContainer>
        );
    }
}

export default MaintainabilityChart;




// WEBPACK FOOTER //
// ./src/lib/components/Charts/MaintainabilityChart.js